<div class="row">
  <div class="col-md-10 eweb-links-button-background">
    <ng-container *ngIf="shouldShowManageMyWebsite">
      <button
        (click)="fetchManageMySiteUrl.emit(true)"
        class="col-12 btn button-border normal-font"
      >
        <div class="row">
          <div class="col-sm-4 col-12 text-center align-self-center">
            <img
              id="manage"
              src="assets/ewx_icons/manage_my_site.png"
              alt="Gear and wrench"
            />
          </div>
          <div class="col-sm-8 col-12 text-center align-self-center">
            <div>Manage My Website</div>
          </div>
        </div>
      </button>
    </ng-container>

    <button
      (click)="fetchManageMyOmiUrl.emit(true)"
      *ngIf="isOmi"
      class="col-12 btn button-border normal-font"
    >
      <div class="row">
        <div class="col-sm-4 col-12">
          <img
            id="omiIntegration"
            src="assets/ewx_icons/omi_integration.png"
            alt="Integration Arrows"
          />
        </div>
        <div class="col-sm-8 col-12 align-self-center text-center">
          <div>Manage Officemate Integration</div>
        </div>
      </div>
    </button>

    <button
      (click)="openNewWindow(LINKS_TRAINING)"
      class="col-12 btn button-border normal-font"
    >
      <div class="row">
        <div class="col-sm-4 col-12">
          <img
            id="training"
            src="assets/ewx_icons/training_icon.png"
            alt="Computer monitor"
          />
        </div>
        <div class="col-sm-8 col-12 align-self-center text-center">
          <div>Training & Documentation</div>
        </div>
      </div>
    </button>

    <button
      (click)="openNewWindow(LINKS_IMAGES)"
      class="col-12 btn button-border normal-font"
    >
      <div class="row">
        <div class="col-sm-4 col-12">
          <img
            id="images"
            src="assets/ewx_icons/licensed_images.png"
            alt="Scenic Image"
          />
        </div>
        <div class="col-sm-8 col-12 align-self-center text-center">
          <div>Images</div>
        </div>
      </div>
    </button>

    <button
      (click)="openNewWindow(LINKS_TEMPLATE)"
      class="col-12 btn button-border normal-font"
    >
      <div class="row">
        <div class="col-sm-4 col-12">
          <img
            id="templates"
            src="assets/ewx_icons/website_templates.png"
            alt="Template swatch"
          />
        </div>
        <div class="col-sm-8 col-12 align-self-center text-center">
          <div>Website Templates</div>
        </div>
      </div>
    </button>

    <button
      (click)="openNewWindow(LINKS_WEBMAIL)"
      class="col-12 btn button-border normal-font"
    >
      <div class="row">
        <div class="col-sm-4 col-12 text-center-align-self-center">
          <img
            id="email"
            src="assets/ewx_icons/check_your_email.png"
            alt="Envelope with letter inside"
          />
        </div>
        <div class="col-sm-8 col-12 text-center align-self-center">
          <div>Login to Webmail</div>
        </div>
      </div>
    </button>
  </div>
</div>
